import Learn from "./learn";

export default Learn;